<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Honor</div>
            <!-- <div class="header-title">荣誉资质</div> -->
        </div>
        <!-- 成功案例 -->
        <div class="" style="margin: 60px 0;">
            <div class="">
                <div class="w">
                    <div class="flex-row flex-wrap justify-center">
                        <div class="flex-row flex-wrap justify-between">
                        <div @click="page('cases')" class="cases-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in honorSrc">
                            <!-- <img src="@/assets/img/honor/Cases.png" style="width: 100%;height: 100%;" alt=""> -->
                            <img :src="http.ipAddress+item.filePath"
                            style="width: 100%;height: 100%;" >

                            <!-- <div class="item-name">{{item.name}}</div> -->
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            honorSrc:[
                // {
                //     name:"",
                //     img:"荣誉资质-01.jpg",
                //     path:""
                // }
                // ,{
                //     name:"",
                //     img:"荣誉资质-02.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-03.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-04.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-05.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-06.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-07.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-08.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-09.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-10.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-11.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-12.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-13.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-14.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-15.jpg",
                //     path:""
                // },{
                //     name:"",
                //     img:"荣誉资质-16.jpg",
                //     path:""
                // }
            ]
        }
    },
    methods: {
        page() {
            this.$router.push(''); 
        }
    },
    mounted() {
            debugger
            let that=this;
            this.http.post("/api/FJ_Honor/GetAllHonor",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.honorSrc=objResult.data;
                }
            });
        }
}
</script>


<style scoped lang="scss">
.header {
    background: url('../../assets/img/honorbanner.jpg') no-repeat;
    background-size: 100% ;
}
.cases-item {
    width: 33.3%;
    padding: 30px;
    box-sizing: border-box;
    /* border: 1px solid #eee; */
}

.cases-item:nth-child(3n - 1) {
    border-left: none;
    border-right: none;
}

/* .products-item.active {
    border-color: #0AA00A;
} */
</style>


// WEBPACK FOOTER //
// src/views/honor/index.vue